import styled from 'styled-components';

export const StyledHorizontalMenu = styled.div`
  width: 100%;

  .horizontal-menu {
    gap: 48px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    row-gap: 12px;

    a {
      text-transform: uppercase;
      white-space: nowrap;
    }

    &__item {
      text-align: center;

      p {
        margin: 0;
      }
    }
  }

  @media (max-width: 1150px) {
    .horizontal-menu {
      gap: 32px;
      row-gap: 10px;
    }
  }
`;
